import MobileApi from 'lib/MobileApi';

/**
 * Custom hook for handling Picture-in-Picture requests from the Omega Player.
 * This hook provides a standardized way to handle PiP requests across the WebApp.
 *
 * @returns {Function} A function that handles PiP requests and communicates with the native Android layer
 */
export const usePipRequest = () => {
  /**
   * Handles Picture-in-Picture requests from the Omega Player.
   * This function is called when the user clicks the PiP button in the video player.
   * It communicates with the native Android layer to enter PiP mode.
   *
   * @returns {void}
   */
  const handlePipRequest = () => {
    console.log(
      '### DEBUG WEBAPP: usePipRequest - STEP 1 - inside `handlePipRequest`, PiP requested. Calling MobileApi.triggerNativePip...',
    );

    if (typeof window !== 'undefined') {
      console.log(
        '### DEBUG WEBAPP: usePipRequest - STEP 2 - Window object is available, proceeding with PiP request...',
      );
      try {
        MobileApi.triggerNativePip();
        console.log('### DEBUG WEBAPP: usePipRequest - STEP 3 - MobileApi.triggerNativePip called.');
      } catch (error) {
        console.error(
          '### DEBUG WEBAPP: usePipRequest - ERROR - Failed to trigger native PiP via MobileApi:',
          error,
        );
      }
    } else {
      console.warn(
        '### DEBUG WEBAPP: usePipRequest - STEP 4 - Window object not available (server-side rendering)',
      );
    }
  };

  console.log(
    '### DEBUG WEBAPP: usePipRequest - STEP 5 - Workflow completed, returning handlePipRequest function',
  );
  return handlePipRequest;
};
